import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import i18next from "i18next";
import { RootState } from "../..";
import { selectRoomParticipantName } from "../room/selectors";
import type { IChatState, ChatMessage } from "./types";

export const addChatMessage = createAsyncThunk(
  'chat/addChatMessage',
  async (message: ChatMessage, { getState }) => {
    const state = getState() as RootState;
    const name = selectRoomParticipantName(message.sender)(state);

    return {
      ...message,
      name: name || i18next.t('you'),
    };
  }
);

const initialState: IChatState = {
  messages: [],
};

const chatSlice = createSlice({
  name: "Chat",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addChatMessage.fulfilled, (state, action) => {
        state.messages.push(action.payload);
      });
  },
});

export default chatSlice.reducer;
